import { ChatMessage } from '@/core/models/chat-room.model'

export function isQuillContentEmpty(htmlContent: string): boolean {
  if (!htmlContent) return true
  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = htmlContent
  const textContent = tempDiv.textContent || ''
  const hasImages = tempDiv.querySelector('img') !== null
  return textContent.trim().length === 0 && !hasImages
}

export function isTextFieldEmpty(content: string): boolean {
  return !content || content.trim().length === 0
}

export function isLastMessageFromSender(messages: ChatMessage[], messageIndex: number, authorId: string): boolean {
  for (let i = messageIndex + 1; i < messages.length; i++) {
    if (messages[i].author === authorId) {
      return false
    }
  }
  return true
}
